import React from 'react';
import './ui.css';

export function YCheckbox({ id, label, checked, onChange, disabled = false, className = '' }) {
  return (
    <label className={`y-checkbox ${className}`.trim()}>
      <input
        id={id}
        type="checkbox"
        className="y-checkbox-input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="y-checkbox-box" aria-hidden="true" />
      <span className="y-checkbox-label">{label}</span>
    </label>
  );
}
